import styled from 'styled-components';
import React from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { SearchTabs } from '../../ui/SearchTabs';
import {
  FORM_VALUES,
  LEASED_TYPES_NEW_ADD
} from '../../../utils/helpers/constants';
import { TabVariantEnum } from '../../ui/SearchTabs/types';
import useScreenSize from '../../../hooks/useScreenSize';
import { generateDataStat } from '../../../utils/helpers/generateDataStat';

export const TabsWrapper = styled.div`
  width: 100%;

  ul {
    width: 100%;
    min-width: auto;
  }
`;

interface DealTypeTabsProps {
  dataStats: { value: string; dataStat: string }[];
}

export const DealTypeTabs: React.FC<DealTypeTabsProps> = ({ dataStats }) => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change } = useForm();
  const { isSmall } = useScreenSize();
  const paidDaily = values[FORM_VALUES.paidDaily];

  const handleTabClick = (value: string) => {
    change(FORM_VALUES.leased, value);

    if (value === 'true' && !paidDaily) {
      change(FORM_VALUES.paidDaily, 'false');
    }
  };

  const tabsTitles = LEASED_TYPES_NEW_ADD.map(type => {
    const tabStat = dataStats.find(stat => stat.value === type.value)?.dataStat;

    return {
      name: type.id,
      label: t(type.name),
      isSelected: type.value === values[FORM_VALUES.leased],
      stat: generateDataStat(tabStat || '', isSmall) || '',
      onClick: () => handleTabClick(type.value)
    };
  });

  return (
    <TabsWrapper>
      <SearchTabs
        titles={tabsTitles}
        disabled={false}
        variant={TabVariantEnum.Blue}
        height={54}
      />
    </TabsWrapper>
  );
};
